import '../Display.css'


const DeathFilter = (props) => {
  return (
    <select
      className="dropDown"
      onChange={props.onChangeHandler}
      value={props.filter}
    >
      <option value="all" default>
        Select a category...
      </option>
      <option value="all">All</option>
      <option value="apoptosis">Apoptosis (general)</option>
      <option value="intrinsic_pathway">Intrinsic apoptosis</option>
      <option value="extrinsic_pathway">Extrinsic apoptosis</option>
      <option value="autophagic">Autophagic</option>
      <option value="entosis">Entosis</option>
      <option value="ferroptosis">Ferroptosis</option>
      <option value="immunogenic">Immunogenic</option>
      <option value="necroptosis">Necroptosis</option>
      <option value="netosis">NETosis</option>
      <option value="parthanatos">Parthanatos</option>
      <option value="pyroptosis">Pyroptosis</option>
    </select>
  );
};

export default DeathFilter;
